import { URLS } from '@/api/config';
import { ListResponse, RequestContext } from '@/api/types';
import { postRequest } from '@/api/utils/request';

class GlobalService {
  URLS = URLS;

  async getAll<T>(context: RequestContext | null, body?: any): Promise<ListResponse<T>> {
    context = context ?? {};

    const result = await postRequest<ListResponse<T>>(`${context.url}`, body, {
      headers: context.headers,
      signal: context.signal,
    });

    return result;
  }

  async getData<T>(
    service: keyof typeof this.URLS,
    query: Record<string, any> = {}
  ): Promise<ListResponse<T>> {
    if (!query.page) {
      query.page = 1;
    }
    const { lang, ...restBody } = query;
    const url = `${this.URLS[service]}/card`;
    const body = restBody;

    return this.getAll(
      {
        url,
        headers: {
          'Accept-language': lang,
        },
      },
      body
    );
  }

  async getItem<T>(service: keyof typeof this.URLS, body: any): Promise<T> {
    const result = await postRequest<T>(`${URLS[service]}/show`, body, {
      headers: {
        'Accept-language': body.lang,
      },
    });
    return result;
  }

  async post<T>(
    service: keyof typeof this.URLS | string,
    body: any,
    context?: RequestContext | null
  ): Promise<T> {
    const requestURL = this.URLS[service as keyof typeof this.URLS] || service;
    const requestContext = context || {};

    const result = await postRequest<T>(requestURL, body, requestContext);
    return result;
  }
}

export default new GlobalService();
